import React from 'react';
import { Link } from 'react-router-dom';

import Shopify from 'providers/shopify';

import './ThankYouPage.sass';

const ThankYouPage: React.StatelessComponent<{}> = () => {
    Shopify.clearLocalStorage();
    return (
        <div className="thank-you-container">
            <p>Thanks for shopping with Gruhn Guitars!</p>
            <p>Return to the <Link to="/accessories">shop</Link> or the <Link to="/">homepage.</Link></p>
        </div>
    );
};

export default ThankYouPage;



// WEBPACK FOOTER //
// ./src/components/pages/accessories/ThankYouPage.tsx